import { Reducer } from 'redux';
import ActionTypes, { TTicketState } from './types';

export const initialState: TTicketState = {
  error: null,
  loading: false,
  data: null,
};

const reducer: Reducer<TTicketState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_TICKET_R:
      return { ...state, loading: true, error: null };
    case ActionTypes.GET_TICKET_S:
      return { ...state, data: action.payload, loading: false, error: null };
    case ActionTypes.GET_TICKET_E:
      return { ...state, error: action.payload, data: null, loading: false };
    default:
      return state;
  }
};

export { reducer as TicketReducer };
